import axios from '@/api'

export default {
  getAll() {
    return axios.get('/contract-types')
  },
  create(data) {
    return axios.post('/contract-types', data)
  },
  update(id, data) {
    return axios.put(`/contract-types/${id}`, data)
  },
  delete(id) {
    return axios.delete(`/contract-types/${id}`)
  },
  toggleStatus(id) {
    return axios.patch(`/contract-types/${id}/changeStatus`)
  }
}
